import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import Button from '@/components/Button';
import { AgaveDataGrid } from '@/components/GenericTable/DataGridStyled';
import Modal from '@/components/Modals/Modal';

import ReportsModal from './dependencies/ReportsModal';
import { reportsColumns } from './reports-columns';
import useMyReportsSection from './useMyReportsSection';

const MyReportsSection = () => {
  const hook = useMyReportsSection();
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'start',
        justifyContent: 'center',
        padding: 0,
      }}
    >
      <Grid
        container
        size={{ xxs: 12 }}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          padding: theme.spacing(2),
        }}
      >
        <Button variant="contained" onClick={hook.openCloseReportsModal}>
          Crear reporte
        </Button>
      </Grid>

      <Box sx={{ overflowX: 'auto', width: '100%' }}>
        <Box sx={{ minWidth: 700 }}>
          <AgaveDataGrid
            columns={reportsColumns()}
            rows={hook.reports || []}
            loading={hook.loading}
            rowCount={hook.total}
            localeText={{ noRowsLabel: 'No hay reportes disponibles' }}
            getRowId={(row) => row.createdAt}
            disableRowSelectionOnClick
            disableCursorPointer={true}
            hideFooterSelectedRowCount
            disableColumnMenu
            paginationMode="server"
            paginationModel={{
              page: hook.pagination.filters.page as number,
              pageSize: hook.pagination.filters.page_size as number,
            }}
            onPaginationModelChange={hook.pagination.onPaginationModelChange}
          />
        </Box>
      </Box>

      <Modal
        isOpen={hook.openReportsModal}
        onClose={hook.openCloseReportsModal}
        title="Crear reporte"
        maxWidth="sm"
        scroll="body"
      >
        <ReportsModal
          handleNewReport={hook.createReport}
          handleReportFields={hook.handleReportFields}
          reportFields={hook.reportFields}
          openCloseReportsWithRefresh={hook.openCloseReportsWithRefresh}
        />
      </Modal>
    </Paper>
  );
};

export default MyReportsSection;
